import { render } from "./IconInfo.vue?vue&type=template&id=0b1521a2&ts=true"
import script from "./IconInfo.vue?vue&type=script&lang=ts"
export * from "./IconInfo.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__